/**
 * FikoTolerans — 1D Tolerans Yığını (Stack-up) motoru
 * Ölçü zinciri (±tol, yön +/-) → en kötü durum (worst-case) + istatistiksel (RSS).
 */

export interface TolHalka { ad: string; nominal: number; tol: number; yon: 1 | -1; }   // tol = ± yarı aralık

export interface TolSonuc {
  nominalBosluk: number;   // Σ(yön × nominal)
  wcTol: number;           // worst-case ± = Σ|tol|
  wcMin: number; wcMax: number;
  rssTol: number;          // RSS ± = √Σtol²
  rssMin: number; rssMax: number;
}

export function toleransHesapla(halkalar: TolHalka[]): TolSonuc {
  let nominal = 0, wc = 0, rss2 = 0;
  for (const h of halkalar) {
    nominal += (h.yon < 0 ? -1 : 1) * (+h.nominal || 0);
    const t = Math.abs(+h.tol || 0);
    wc += t; rss2 += t * t;
  }
  const rss = Math.sqrt(rss2);
  return {
    nominalBosluk: nominal,
    wcTol: wc, wcMin: nominal - wc, wcMax: nominal + wc,
    rssTol: rss, rssMin: nominal - rss, rssMax: nominal + rss,
  };
}
